<template>
  <v-btn-form :title="title" :mode = "edit" @close="cancel()">
    <v-form v-model="valid" ref="form">
    <v-flex v-if="!isEdit">
        <v-card-title>
          <span class="headline">{{item.name}}</span>
        </v-card-title>
        <v-card-text>
        </v-card-text>
    </v-flex>
    <v-flex v-if="isEdit">
          <v-card-text>
          <v-layout column>
          <v-layout row wrap>
            <v-flex sm8 xs12>
            <v-textarea
              label="Партнер"
              readonly
              auto-grow
              rows="1"
              :value="partnerDescription"
              @click="selectClient"
            ></v-textarea>
          </v-flex>
          <v-flex sm4 xs4>
            <v-btn @click="selectClient">Выбрать партнера</v-btn>
          </v-flex>
          </v-layout>


        <v-flex>
          <v-text-field
            label="Название"
            hint="Название беседы"
            v-model="item.name"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex v-show="isNew">
          <v-text-field
            label="Сообщение"
            hint=""
              clearable
            v-model="item.msg"
          ></v-text-field>
        </v-flex>
      </v-layout>
      </v-card-text>
    </v-flex>
  </v-form>
    <template #actions>
      <v-btn v-if="!isEdit" @click="edit = !edit">Изменить</v-btn>

      <v-btn v-if="isEdit" v-show="!isNew" @click="save">Сохранить</v-btn>
      <v-btn v-if="isEdit" v-show="!isNew" @click="remove">Удалить</v-btn>
      <v-btn v-if="isEdit" v-show="isNew" :disabled="!partner || !partner.clientId" @click="add">Создать</v-btn>
      <v-spacer></v-spacer>
    </template>
</v-btn-form>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import client from '../client/index.js'
  import formats from '../../api/formats'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'chat-form',
    components: {vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      request: '',
      item: {},
      partner: null,
      isSearching: false
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    create () {
      this.item = this.getItemNew()
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
      }),
      isEdit () {
        return this.edit || this.isNew
      },
      isNew () {
        return true
        // Disable functionality to change chat definition
        // this.itemId === null
      },
      title () {
        return this.isNew ? 'Создать беседу' : this.isEdit ? 'Изменить атрибуты беседы' : 'Информация о беседе'
      },
      partnerDescription () {
        var result = this.partner ? this.partner.caption + ' (ИНН:' + formats.formatInn(this.partner.inn) + ')' : ''
        if (this.partner && this.partner.heads) {
          result = result + '\n' + this.formatHeads(this.partner.heads)
        }
        return result
      }

    },
    methods: {
      add () {
        if (this.partner) {
          this.item.partnerInn = this.partner.inn
          this.$store.dispatch('addChatterChat', this.item)
          this.edit = false
          this.cancel()
        }
      },
      save () {
        this.$store.dispatch('updateChatterChat', this.item)
        this.edit = false
      },
      remove () {
        this.$store.dispatch('deleteChatterChat', this.item)
        this.edit = false
        this.cancel()
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      formatHeads (heads) {
        return heads ? heads.map(h => ''.concat(h.position, ': ', h.nameShort)).join('\n') : ''
      },
      getItemNew () {
        return {
          id: null,
          name: null,
          partnerInn: null,
          msg: ''
        }
      },
      setPartner: function (value) {
        this.partner = value.length > 0 ? value[0] : null
      },
      selectClient () {
        client.selectRef(this, this.setPartner, () => {}, null, true, true)
      }
    }

  }

</script>




// WEBPACK FOOTER //
// ChatForm.vue?ce30caca